/**
 * Fallback OHP domains used only when the hospital-domain API is empty or unreachable.
 * Source of truth is HospitalEmailDomain in Postgres.
 */
export const FALLBACK_ONTARIO_HOSPITAL_DOMAINS = [
  'ohri.ca',
  'toh.ca',
  'sunnybrook.ca',
  'mcmaster.ca',
  'uhn.ca',
  'sickkids.ca',
  'lakeridgehealth.on.ca',
  'hsc.mcmaster.ca',
  'queensu.ca',
  'uwo.ca',
  'utoronto.ca',
  'ottawahospital.on.ca',
  'trilliumhealthpartners.ca',
  'williamoslerhs.ca',
  'hrh.ca',
  'humber.ca',
  'mackenziehealth.ca',
  'markhamstouffvillehospital.ca',
  'northyorkgeneral.on.ca',
  'scarboroughhealthnetwork.ca',
  'unityhealth.to',
  'waypointcentre.ca',
  'wrh.on.ca',
] as const;
